import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import auth_guid from "../auth_guid.json";

export abstract class BaseApi {
    protected config = process.env.NODE_ENV === "production"
        ? require("../Config.prod").default
        : require("../Config.local").default;
    
    protected scopeUrl = process.env.NODE_ENV === "production"
        ? "api://" + auth_guid.prod.tenantId + "/User.Read"
        : "https://CBEDevelopWebappTest.onmicrosoft.com/" + auth_guid.local.tenantId + "/User.Read";
    
    protected account: AccountInfo;
    protected msalInstance: IPublicClientApplication;
    protected userToken: string | null;

    constructor(account: AccountInfo, msalInstance: IPublicClientApplication) {
        this.account = account;
        this.msalInstance = msalInstance;
        this.userToken = null;
    }

    protected async refreshToken(): Promise<void> {
        if (!this.userToken) {
            const response = await this.msalInstance.acquireTokenSilent({
                scopes: [this.scopeUrl],
                account: this.account,
            });
            this.userToken = response.accessToken;
        }
    }

    protected getDefaultHeaders() {
        return {
            headers: {
                Authorization: `Bearer ${this.userToken}`,
            },
        };
    }
}